export default {"src":"/_next/static/media/portabellamushrooms.3d18973d.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};